import React from 'react';
import cx from 'classnames';

interface Props {
  children: React.ReactNode;
  className?: string;
}

// we have this component to make sure that the content is hidden from the user
// a screen reader, and search engine crawlers, but not from the markdown compiler
// the markdown compiler is used to compile our pages for Answer Engine Optimization (AEO)
const HideFromUser: React.FC<Props> = ({ children, className }) => {
  return (
    <span data-nosnippet className={cx('hide-for-user', className)}>
      {children}
    </span>
  );
};

export default HideFromUser;
